
define('ldsh!modules/user/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>User</h1>\n<a class="btn btn-default" href="#/user/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   Username\n  </th>\n  \n  <th>\n   Password\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="User-body">\n\t</tbody>\n</table>';

}
return __p
};});

